const SHORT_UUID_ALPHABET =
  "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
const SHORT_UUID_BASE = BigInt(SHORT_UUID_ALPHABET.length)
const SHORT_UUID_LENGTH = 22

function encodeHexAsShortUuid(uuid: string): string {
  const hex = uuid.replace(/-/g, "").toLowerCase()
  let value = BigInt(`0x${hex}`)

  if (value === 0n) {
    return SHORT_UUID_ALPHABET[0].repeat(SHORT_UUID_LENGTH)
  }

  let encoded = ""

  while (value > 0n) {
    const remainder = Number(value % SHORT_UUID_BASE)
    encoded = SHORT_UUID_ALPHABET[remainder] + encoded
    value /= SHORT_UUID_BASE
  }

  return encoded.padStart(SHORT_UUID_LENGTH, SHORT_UUID_ALPHABET[0])
}

/**
 * Generates a ShortUUID compatible with Django's ShortUUIDField.
 *
 * This function creates 22-character, URL-safe, base58-encoded UUIDs
 * without depending on the `short-uuid` package at runtime.
 *
 * @returns A 22-character ShortUUID string
 *
 * @example
 * const agentId = generateShortUUID();
 * // Returns something like: "2cBREFuCZsDabC5f4McMdV"
 */
export function generateShortUUID(): string {
  return encodeHexAsShortUuid(globalThis.crypto.randomUUID())
}
